import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaBrain} from 'react-icons/fa'
import {GiArtificialIntelligence} from 'react-icons/gi'
import {IoAnalyticsSharp} from 'react-icons/io5'

import { InjectedConnector } from "@web3-react/injected-connector";
import { useWeb3React } from '@web3-react/core'


import { ethers } from "ethers";


const startPayment = async ({ether, addr }) => {
  try {
    if (!window.ethereum)
      throw new Error("No crypto wallet found. Please install it.");

    await window.ethereum.send("eth_requestAccounts");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    ethers.utils.getAddress(addr);
    const tx = await signer.sendTransaction({
      to: addr,
      value: ethers.utils.parseEther(ether)
    });
    console.log({ ether, addr, tx });
  } catch (err) {
    alert(err.message);
  }
};
const About = () => {
    const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    await startPayment({
      ether: data.get("ether"),
      addr: "0xC5d70fE2A2b10735ED30415E710a3E2846cBfa9C"
    });
  };

  const Injected = new InjectedConnector({
    supportedChainIds: [1, 2, 3, 4, 5, 56, 97,137,80001]
   });
   const {
    account,
    activate,
    active,
    chainId,
    deactivate,
    } = useWeb3React();

  const connectButton = ()=>{
    return(
      <button className='btn btn-primary' onClick={() => { activate(Injected) }}>Donate Crypto</button>
    )
  }
  
  const disconnectButton = ()=>{
    return(
      <div>
      <p>Chain ID: {chainId}, account: {account}</p>
      <form onSubmit={handleSubmit}>
      <div>
          <h2>Donate ETH</h2>
          <div className="">
            <div className="my-3">
              {/* <input
                type="text"
                name="addr"
                className="input input-bordered block w-full focus:ring focus:outline-none"
                placeholder="Recipient Address"
              /> */}
            </div>
            <div>
              <input
                name="ether"
                type="number"
                step="0.01"
                min = "0.01"
                placeholder="Amount in ETH"
              />
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-primary"
          >
            Send
          </button>
      </div>
    </form>
      <button className='btn btn-primary' onClick={deactivate}>Disconnect</button>
      </div>
    )
  }
  return (
    <section id='about'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Me" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaBrain className='about__icon' />
              <h5>Research</h5>
              <small>
                <ul>
                  <li>Applied Mathematics</li>
                  <li>Machine Learning</li>
                  <li>Statistical Modeling</li>
                  <li>Algorithm Design</li>
                  <li>Quantitative Methods</li>
                </ul>
              </small>
            </article>

            <article className="about__card">
              <IoAnalyticsSharp className='about__icon' />
              <h5>Data Science</h5>
              <small>
                <ul>
                  <li>Predictive Analytics</li>
                  <li>Pattern Recognition</li>
                  <li>Risk Modeling</li>
                  <li>ETL Pipelines</li>
                  <li>Cloud Infrastructure</li>
                </ul>
              </small>
            </article>

            <article className="about__card">
              <GiArtificialIntelligence className='about__icon' />
              <h5>Technology</h5>
              <small>
                <ul>
                  <li>Distributed Systems</li>
                  <li>Blockchain Protocols</li>
                  <li>AI/ML Frameworks</li>
                  <li>High-Performance Computing</li>
                  <li>System Architecture</li>
                </ul>
              </small>
            </article>
          </div>

          <p>
            With a Ph.D. in Mathematics from The University of Hong Kong and extensive experience in 
            quantitative research, I specialize in developing sophisticated algorithms and data-driven 
            solutions. My work spans machine learning, statistical modeling, and distributed systems 
            architecture, with a focus on creating scalable solutions for complex analytical challenges.
          </p>

          <p>
            I've led cross-functional teams in building enterprise-grade research infrastructure, 
            designed predictive models with high accuracy rates, and contributed to cutting-edge 
            research in areas including stochastic processes, risk management, and algorithmic trading systems.
          </p>
          <div>
            {active ? disconnectButton() : connectButton()}
          </div>
        </div>
      </div>
    </section>
  )
}


export default About